import React from "react"
import { AnchorLink } from "gatsby-plugin-anchor-links"
import styled from "styled-components/macro"
import MoreInfo from "../MoreInfo/MoreInfo"
import Button from "../Button/Button"
import useFacilityData from "../../hooks/useFacilityData.ts"
import { paramCase } from "param-case"
import ServiceIcon from "../../images/format_list_bulleted-24px.svg"

const ServiceNavStyles = styled.section`
  margin: 75px 0 0;
  .Button {
    margin-right: 0;
    @media screen and (min-width: 790px) {
      margin-right: 30px;
      &:last-child {
        margin-right: 0;
      }
    }
  }
`

const ServiceNav = ({ currTitle }) => {
  const facilityData = useFacilityData()

  const serviceArr = facilityData.sanityFacility.facilityObj.services.filter(
    service => service.title !== currTitle
  )

  const serviceNavList = serviceArr.map(service => (
    <Button
      key={service._key}
      size="m"
      element={AnchorLink}
      to={`/${paramCase(service.title)}`}
      icon={<ServiceIcon />}
    >
      {service.title}
    </Button>
  ))

  return (
    <ServiceNavStyles>
      <MoreInfo title="Our Other Services">{serviceNavList}</MoreInfo>
    </ServiceNavStyles>
  )
}

export default ServiceNav
